import { render, staticRenderFns } from "./GymRouteClimbingSimpleStyleIcons.vue?vue&type=template&id=2d359a02"
import script from "./GymRouteClimbingSimpleStyleIcons.vue?vue&type=script&lang=js"
export * from "./GymRouteClimbingSimpleStyleIcons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports